import Axios from "axios";
import { CMSPath } from "../config/constant";


export const activity_booking_base_url = Axios.create({ baseURL: `${CMSPath}/spaWebApplication/rest`});

export const getActivityLocations = async (locationId) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": {
            "spaLocationId": locationId
        }
    }

    try {
        const response = await activity_booking_base_url.post("/getSpaTreatments", payload);
        return response;
    } catch (err) {
        return err;
    }

}



export const getMyActivities = async () => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": {

        }
    }

    try {
        const response = await activity_booking_base_url.post("/getAllAppointment", payload);
        return response;
    } catch (err) {
        return err;
    }

}



export const getAvailableActivities = async (payload_) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload_
    }

    try {
        const response = await activity_booking_base_url.post("/searchSpaAvailability", payload);
        return response;
    } catch (err) {
        return err;
    }

}




export const bookMyActivity = async (payload_) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload_
    }

    try {
        const response = await activity_booking_base_url.post("/saveAppointment", payload);
        return response;
    } catch (err) {
        return err;
    }

}


export const cancelMyActivityBooking = async (payload_) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload_
    }

    try {
        const response = await activity_booking_base_url.post("/cancelAppointment", payload);
        return response;
    } catch (err) {
        return err;
    }

}

export const updateMyActivity = async (payload_) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "reservationNumber": currentUserInfo[0].reservationNumber,
            "guestToken": currentUserInfo[0].guestToken,
        },
        "payload": payload_
    }

    try {
        const response = await activity_booking_base_url.post("/updateAppointment", payload);
        return response;
    } catch (err) {
        return err;
    }

}